import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';

import { effects } from './shared/store';
import { userReducer } from './shared/store/reducers/user.reducer';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { teamReducer } from './shared/store/reducers/team.reducer';
import { taskReducer } from './shared/store/reducers/task.reducer';
import { weightReducer } from './shared/store/reducers/weights.reducer';
// import { nutritionReducer } from './shared/store/reducers/nutrition.reducer';
import { reviewsReducer } from './shared/store/reducers/reviews.reducer';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { perimeterReducer } from './shared/store/reducers/perimeters.reducer';
import { doubtsReducer } from './shared/store/reducers/doubts.reducer';
import { foldsReducer } from './shared/store/reducers/folds.reducer';
// import { recoveriesReducer } from './shared/store/reducers/recoveries.reducer';
import { resourcesReducer } from './shared/store/reducers/resources.reducer';


const avaliablesLanguages = ['es-ES', 'en-GB'];

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "../assets/i18n/", ".json");
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    StoreModule.forRoot({
      userData: userReducer,
      teamData: teamReducer,
      taskData: taskReducer,
      reviewsData: reviewsReducer,
      weightsData: weightReducer,
      perimetersData: perimeterReducer,
      doubtsData: doubtsReducer,
      foldsData: foldsReducer,
      resourcesData: resourcesReducer,
      // recoveriesData: recoveriesReducer
    }), // nutritionData: nutritionReducer
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    EffectsModule.forRoot(effects),
    TranslateModule.forRoot({
      defaultLanguage: avaliablesLanguages.includes(window.navigator.language) ? window.navigator.language : 'es-ES',
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideMessaging(() => getMessaging()),
    provideAuth(() => getAuth()),
    provideHttpClient(),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }